import styled from 'styled-components'
import { breackpoints, cores } from '../../styles'

export const Header = styled.header`
  background-color: ${cores.azul};

  & > div {
    display: flex;
    justify-content: space-between;
  }

  @media (max-width: ${breackpoints.desktop}) {
    padding: 0 20px;
  }
`

export const Menu = styled.div`
  display: flex;
  align-items: center;

  a {
    margin-right: 20px;
  }
`

export const Lista = styled.ul`
  display: flex;
  li {
    a {
      line-height: 70px;
      color: ${cores.branco};
      opacity: 0.8;

      &:hover {
        opacity: 1;
      }
    }
  }

  @media (max-width: ${breackpoints.desktop}) {
    display: none;
  }
`

export const Button = styled.button`
  padding: 9px 16px;
  border: 1px solid ${cores.branco};
  border-radius: 36px;
  background-color: transparent;
  color: ${cores.branco};
  opacity: 0.8;
  cursor: pointer;

  &:hover {
    opacity: 1;
    background-color: ${cores.azulClaro};
  }

  @media (max-width: ${breackpoints.desktop}) {
    display: none;
  }
`
